<template>
    <teleport to="body">
        <div class="booking-dialog-overlay" @click.self="Close()">
            <div class="booking-dialog" role="dialog" aria-modal="true" aria-label="Booking details">
                <button type="button" class="booking-dialog-close" title="Close" aria-label="Close" @click="Close()">×</button>
                <details_content :in_dialog="true" @booking_cancelled="Booking_Cancelled"></details_content>
            </div>
        </div>
    </teleport>
</template>

<script lang="ts" src="./details_dialog.ts"></script>
